import { gql } from 'urql';

const GetPresignedUpload = gql`
  query GetPresignedUpload($count: Int, $format: DocumentFormat) {
    presignedUpload(count: $count, format: $format) {
      id
      uploadUrl
      previewUrl
      file
      method
      form {
        name
        value
      }
    }
  }
`;
export default GetPresignedUpload;
